var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "hcpModal",
        "data-focus": "false",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-dialog-scrollable modal-lg" },
        [
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _c("ValidationObserver", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit }) {
                      return [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("h5", { staticClass: "modal-title" }, [
                            _vm._v("HCP 人事資料維護"),
                          ]),
                        ]),
                        _c("div", { staticClass: "modal-body" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("員工編號"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.EmployeeNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "EmployeeNo",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.EmployeeNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("英文姓名"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "50",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.EnglishName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "EnglishName",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.EnglishName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Plant"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          filterable: "",
                                          "allow-create": "",
                                          clearable: "",
                                          "value-key": "Guid",
                                          placeholder: "請選擇",
                                        },
                                        on: {
                                          change: function ($event) {
                                            ;(_vm.deptOptions = []),
                                              (_vm.hcp.EmployeeDepartment =
                                                null)
                                          },
                                        },
                                        model: {
                                          value: _vm.hcp.EmployeePlant,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "EmployeePlant",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.EmployeePlant",
                                        },
                                      },
                                      _vm._l(
                                        _vm.plantOptions,
                                        function (plant) {
                                          return _c("el-option", {
                                            key: plant.Guid,
                                            attrs: {
                                              label: plant.Name,
                                              value: plant,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("所在部門"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          filterable: "",
                                          clearable: "",
                                          "allow-create": "",
                                          "value-key": "Guid",
                                          placeholder: "請先選擇 Plant",
                                        },
                                        model: {
                                          value: _vm.hcp.EmployeeDepartment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "EmployeeDepartment",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.EmployeeDepartment",
                                        },
                                      },
                                      _vm._l(_vm.deptOptions, function (dept) {
                                        return _c("el-option", {
                                          key: dept.Guid,
                                          attrs: {
                                            label: dept.Name,
                                            value: dept,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("部門代碼"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.EmployeeGroupCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "EmployeeGroupCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.EmployeeGroupCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("刷卡卡別"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.CardType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "CardType",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.CardType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("年假代號"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.AnnualLeaveCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "AnnualLeaveCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.AnnualLeaveCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("員工分類(代號)"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.EmployeeTypeCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "EmployeeTypeCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.EmployeeTypeCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("銀行代碼"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.BankCode,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.hcp, "BankCode", $$v)
                                          },
                                          expression: "hcp.BankCode",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "郵局(700)",
                                            value: "700",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "中國信託(822)",
                                            value: "822",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("銀行帳號"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "20",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.BankAccount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "BankAccount",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.BankAccount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("稅別"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.TaxCategoryCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "TaxCategoryCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.TaxCategoryCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("職稱類別"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.JobTitleCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "JobTitleCode",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.JobTitleCode",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "管理職",
                                            value: "管理職",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "技術職",
                                            value: "技術職",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "事務職",
                                            value: "事務職",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "技能職",
                                            value: "技能職",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("是否為外籍配偶"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.ForeignSpouseType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "ForeignSpouseType",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.ForeignSpouseType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "外籍配偶",
                                            value: "外籍配偶",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "大陸配偶",
                                            value: "大陸配偶",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "長期居留",
                                            value: "長期居留",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("考勤卡號"),
                                    ]),
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        clearable: "",
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        placeholder: "請輸入",
                                      },
                                      model: {
                                        value: _vm.hcp.CardNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "CardNo",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "hcp.CardNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("聘僱類別"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.EmploymentType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "EmploymentType",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.EmploymentType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "藍領",
                                            value: "藍領",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "白領",
                                            value: "白領",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "產學合作",
                                            value: "產學合作",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "部份工時",
                                            value: "部份工時",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("身份別"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.IdentityType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "IdentityType",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.IdentityType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "IDL", value: "IDL" },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "IDL工讀生",
                                            value: "IDL工讀生",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "DL", value: "DL" },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "按摩師",
                                            value: "按摩師",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label:
                                              "DL產學合作4+2產學生(高中畢業)",
                                            value:
                                              "DL產學合作4+2產學生(高中畢業)",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label:
                                              "DL產學合作1年期實習生(大四學生)",
                                            value:
                                              "DL產學合作1年期實習生(大四學生)",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "外籍",
                                            value: "外籍",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("身份類型"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "form-group radio-style" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.IdentityClass,
                                          expression: "hcp.IdentityClass",
                                        },
                                      ],
                                      attrs: {
                                        id: "IdentityClass1",
                                        type: "radio",
                                        value: "身份證",
                                        disabled:
                                          !_vm.$Permission.Appointment
                                            .DLPermission.IsValid,
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.IdentityClass,
                                          "身份證"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.IdentityClass
                                            ? (_vm.hcp.IdentityClass = null)
                                            : "身份證"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "IdentityClass",
                                            "身份證"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "mr-4",
                                        attrs: { for: "IdentityClass1" },
                                      },
                                      [_vm._v("身份證")]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.IdentityClass,
                                          expression: "hcp.IdentityClass",
                                        },
                                      ],
                                      attrs: {
                                        id: "IdentityClass2",
                                        type: "radio",
                                        value: "護照居留證號",
                                        disabled:
                                          !_vm.$Permission.Appointment
                                            .DLPermission.IsValid,
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.IdentityClass,
                                          "護照居留證號"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.IdentityClass
                                            ? (_vm.hcp.IdentityClass = null)
                                            : "護照居留證號"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "IdentityClass",
                                            "護照居留證號"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "IdentityClass2" } },
                                      [_vm._v("護照/居留證號")]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("錄用類型"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "form-group radio-style" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.EmployCategory,
                                          expression: "hcp.EmployCategory",
                                        },
                                      ],
                                      attrs: {
                                        id: "EmployCategory1",
                                        type: "radio",
                                        value: "新人錄用",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.EmployCategory,
                                          "新人錄用"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.EmployCategory
                                            ? (_vm.hcp.EmployCategory = null)
                                            : "新人錄用"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "EmployCategory",
                                            "新人錄用"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "mr-4",
                                        attrs: { for: "EmployCategory1" },
                                      },
                                      [_vm._v("新人錄用")]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.EmployCategory,
                                          expression: "hcp.EmployCategory",
                                        },
                                      ],
                                      attrs: {
                                        id: "EmployCategory2",
                                        type: "radio",
                                        value: "老人回廠/舊年資併計",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.EmployCategory,
                                          "老人回廠/舊年資併計"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.EmployCategory
                                            ? (_vm.hcp.EmployCategory = null)
                                            : "老人回廠/舊年資併計"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "EmployCategory",
                                            "老人回廠/舊年資併計"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "EmployCategory2" } },
                                      [_vm._v("老人回廠／舊年資併計")]
                                    ),
                                    _c("br"),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.EmployCategory,
                                          expression: "hcp.EmployCategory",
                                        },
                                      ],
                                      attrs: {
                                        id: "EmployCategory3",
                                        type: "radio",
                                        value: "老人回廠/新人錄用",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.EmployCategory,
                                          "老人回廠/新人錄用"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.EmployCategory
                                            ? (_vm.hcp.EmployCategory = null)
                                            : "老人回廠/新人錄用"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "EmployCategory",
                                            "老人回廠/新人錄用"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "EmployCategory2" } },
                                      [_vm._v("老人回廠／新人錄用")]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("任用部門"),
                                    ]),
                                    _c("treeselect", {
                                      attrs: {
                                        options: _vm.departmentOptions,
                                        "show-count": true,
                                        "default-expand-level": 1,
                                        placeholder: "請選擇",
                                      },
                                      model: {
                                        value:
                                          _vm.hcp.AppointmentDepartmentGuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "AppointmentDepartmentGuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "hcp.AppointmentDepartmentGuid",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("聘僱期間(起)"),
                                    ]),
                                    _c("el-date-picker", {
                                      staticClass: "w-100",
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        placeholder: "請選擇",
                                      },
                                      model: {
                                        value: _vm.hcp.EmploymentStart,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "EmploymentStart",
                                            $$v
                                          )
                                        },
                                        expression: "hcp.EmploymentStart",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("聘僱期間(迄)"),
                                    ]),
                                    _c("ValidationProvider", {
                                      staticClass: "w-100",
                                      attrs: {
                                        name: "聘僱期間(迄)",
                                        rules: {
                                          notBeforeStartDate:
                                            _vm.hcp.EmploymentStart,
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "date",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder: "請選擇",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hcp.EmploymentEnd,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.hcp,
                                                        "EmploymentEnd",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "hcp.EmploymentEnd",
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("職等"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          disabled:
                                            !_vm.$Permission.Appointment
                                              .DLPermission.IsValid,
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.Rank,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.hcp, "Rank", $$v)
                                          },
                                          expression: "hcp.Rank",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "1", value: "1" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "2", value: "2" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "2.1", value: "2.1" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "2.2", value: "2.2" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "3", value: "3" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "4", value: "4" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "5", value: "5" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "6", value: "6" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "6.3", value: "6.3" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "7", value: "7" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "7.3", value: "7.3" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "8", value: "8" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "8.3", value: "8.3" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "9", value: "9" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "9.3", value: "9.3" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "10", value: "10" },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "10.3",
                                            value: "10.3",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "10.5",
                                            value: "10.5",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "10.7",
                                            value: "10.7",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "11", value: "11" },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "11.3",
                                            value: "11.3",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "11.5",
                                            value: "11.5",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "12", value: "12" },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "13", value: "13" },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "13.3",
                                            value: "13.3",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("任用職稱"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          disabled:
                                            !_vm.$Permission.Appointment
                                              .DLPermission.IsValid,
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.AppointmentPosition,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "AppointmentPosition",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.AppointmentPosition",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "生產助理員",
                                            value: "生產助理員",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "助理",
                                            value: "助理",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "技術助理員",
                                            value: "技術助理員",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "技術員",
                                            value: "技術員",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "高級技術員",
                                            value: "高級技術員",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "事務員",
                                            value: "事務員",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "資深技術員",
                                            value: "資深技術員",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "組長",
                                            value: "組長",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "儲備組長",
                                            value: "儲備組長",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "工讀生",
                                            value: "工讀生",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "實習生",
                                            value: "實習生",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "按摩師",
                                            value: "按摩師",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("工作時間"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "form-group radio-style" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.WorkTimeType,
                                          expression: "hcp.WorkTimeType",
                                        },
                                      ],
                                      attrs: {
                                        id: "WorkTimeType1",
                                        type: "radio",
                                        value: "一般工時",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.WorkTimeType,
                                          "一般工時"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.WorkTimeType
                                            ? (_vm.hcp.WorkTimeType = null)
                                            : "一般工時"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "WorkTimeType",
                                            "一般工時"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "mr-4",
                                        attrs: { for: "WorkTimeType1" },
                                      },
                                      [_vm._v("一般工時")]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.WorkTimeType,
                                          expression: "hcp.WorkTimeType",
                                        },
                                      ],
                                      attrs: {
                                        id: "WorkTimeType2",
                                        type: "radio",
                                        value: "特殊工時",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.WorkTimeType,
                                          "特殊工時"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.WorkTimeType
                                            ? (_vm.hcp.WorkTimeType = null)
                                            : "特殊工時"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "WorkTimeType",
                                            "特殊工時"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "WorkTimeType2" } },
                                      [_vm._v("特殊工時")]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm.hcp.WorkTimeType === "一般工時"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("班別"),
                                          ]),
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "請選擇",
                                              },
                                              on: {
                                                change: _vm.changeWorkShift,
                                              },
                                              model: {
                                                value:
                                                  _vm.hcp.WorkShiftTypeGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.hcp,
                                                    "WorkShiftTypeGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "hcp.WorkShiftTypeGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.shiftOptions,
                                              function (shift) {
                                                return _c("el-option", {
                                                  key: shift.Guid,
                                                  attrs: {
                                                    label: shift.Name,
                                                    value: shift.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.WorkShiftTypeGuid ===
                              "11111111-1111-1111-1111-111111111111"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("班別描述")]
                                            ),
                                            _c("el-input", {
                                              attrs: {
                                                clearable: "",
                                                maxlength: "20",
                                              },
                                              model: {
                                                value:
                                                  _vm.hcp.WorkShiftTypeDesc,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.hcp,
                                                    "WorkShiftTypeDesc",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "hcp.WorkShiftTypeDesc",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("休息分鐘數")]
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                min: 0,
                                                max: 999,
                                                step: 1,
                                                precision: 0,
                                              },
                                              model: {
                                                value: _vm.hcp.BreakMinute,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.hcp,
                                                    "BreakMinute",
                                                    $$v
                                                  )
                                                },
                                                expression: "hcp.BreakMinute",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("每日工時")]
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                min: 0,
                                                max: 24,
                                                step: 1,
                                                precision: 0,
                                              },
                                              model: {
                                                value: _vm.hcp.DailyWorkHour,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.hcp,
                                                    "DailyWorkHour",
                                                    $$v
                                                  )
                                                },
                                                expression: "hcp.DailyWorkHour",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("每週工時")]
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                min: 0,
                                                max: 168,
                                                step: 1,
                                                precision: 0,
                                              },
                                              model: {
                                                value: _vm.hcp.WeeklyWorkHour,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.hcp,
                                                    "WeeklyWorkHour",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "hcp.WeeklyWorkHour",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm.hcp.WorkTimeType === "特殊工時"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("特殊出勤類型"),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group radio-style",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.hcp.SpecialWorkTimeType,
                                                expression:
                                                  "hcp.SpecialWorkTimeType",
                                              },
                                            ],
                                            attrs: {
                                              id: "SpecialWork1",
                                              type: "radio",
                                              value: "週一至週五",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hcp.SpecialWorkTimeType,
                                                "週一至週五"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.hcp.SpecialWorkTimeType
                                                  ? (_vm.hcp.SpecialWorkTimeType =
                                                      null)
                                                  : "週一至週五"
                                              },
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.hcp,
                                                  "SpecialWorkTimeType",
                                                  "週一至週五"
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "mr-4",
                                              attrs: { for: "SpecialWork1" },
                                            },
                                            [_vm._v("週一至週五")]
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.hcp.SpecialWorkTimeType,
                                                expression:
                                                  "hcp.SpecialWorkTimeType",
                                              },
                                            ],
                                            attrs: {
                                              id: "SpecialWork2",
                                              type: "radio",
                                              value: "約定工時",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hcp.SpecialWorkTimeType,
                                                "約定工時"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.hcp.SpecialWorkTimeType
                                                  ? (_vm.hcp.SpecialWorkTimeType =
                                                      null)
                                                  : "約定工時"
                                              },
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.hcp,
                                                  "SpecialWorkTimeType",
                                                  "約定工時"
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "SpecialWork2" } },
                                            [_vm._v("約定工時")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.WorkTimeType === "特殊工時" &&
                              _vm.hcp.SpecialWorkTimeType === "約定工時"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("約定週工時")]
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                min: 0,
                                                max: 168,
                                                step: 1,
                                                precision: 0,
                                              },
                                              model: {
                                                value:
                                                  _vm.hcp.SpecialWeeklyHour,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.hcp,
                                                    "SpecialWeeklyHour",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "hcp.SpecialWeeklyHour",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("約定月工時")]
                                            ),
                                            _c("el-input-number", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                min: 0,
                                                max: 744,
                                                step: 1,
                                                precision: 0,
                                              },
                                              model: {
                                                value:
                                                  _vm.hcp.SpecialMonthlyHour,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.hcp,
                                                    "SpecialMonthlyHour",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "hcp.SpecialMonthlyHour",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("薪制"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "form-group radio-style" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.SalaryType,
                                          expression: "hcp.SalaryType",
                                        },
                                      ],
                                      attrs: {
                                        id: "SalaryType1",
                                        type: "radio",
                                        value: "時薪",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.SalaryType,
                                          "時薪"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.SalaryType
                                            ? (_vm.hcp.SalaryType = null)
                                            : "時薪"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "SalaryType",
                                            "時薪"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "mr-4",
                                        attrs: { for: "SalaryType1" },
                                      },
                                      [_vm._v("時薪")]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.SalaryType,
                                          expression: "hcp.SalaryType",
                                        },
                                      ],
                                      attrs: {
                                        id: "SalaryType2",
                                        type: "radio",
                                        value: "月薪",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.SalaryType,
                                          "月薪"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.SalaryType
                                            ? (_vm.hcp.SalaryType = null)
                                            : "月薪"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "SalaryType",
                                            "月薪"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "SalaryType2" } },
                                      [_vm._v("月薪")]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm.hcp.SalaryType === "月薪"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("底薪"),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "底薪",
                                              rules: {
                                                regex: new RegExp(
                                                  /^([0-9,]+)$/
                                                ),
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value:
                                                              _vm.hcp
                                                                .BasicSalary,
                                                            expression:
                                                              "hcp.BasicSalary",
                                                            modifiers: {
                                                              trim: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: {
                                                          disabled:
                                                            !_vm.$Permission
                                                              .Appointment
                                                              .DLPermission
                                                              .IsValid,
                                                          type: "text",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.hcp.BasicSalary,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.hcp,
                                                              "BasicSalary",
                                                              $event.target.value.trim()
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      errors
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.SalaryType === "時薪"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("時薪"),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "時薪",
                                              rules: {
                                                regex: new RegExp(
                                                  /^([0-9,]+)$/
                                                ),
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value:
                                                              _vm.hcp
                                                                .HourSalary,
                                                            expression:
                                                              "hcp.HourSalary",
                                                            modifiers: {
                                                              trim: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value:
                                                            _vm.hcp.HourSalary,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.hcp,
                                                              "HourSalary",
                                                              $event.target.value.trim()
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      errors
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.SalaryType === "月薪"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("交通津貼"),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "交通津貼",
                                              rules: {
                                                regex: new RegExp(
                                                  /^([0-9,]+)$/
                                                ),
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value:
                                                              _vm.hcp
                                                                .TransportationAllowance,
                                                            expression:
                                                              "hcp.TransportationAllowance",
                                                            modifiers: {
                                                              trim: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: {
                                                          type: "text",
                                                          disabled:
                                                            !_vm.$Permission
                                                              .Appointment
                                                              .DLPermission
                                                              .IsValid,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.hcp
                                                              .TransportationAllowance,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.hcp,
                                                              "TransportationAllowance",
                                                              $event.target.value.trim()
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      errors
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.SalaryType === "月薪"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("班次津貼"),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "班次津貼",
                                              rules: {
                                                regex: new RegExp(
                                                  /^([0-9,]+)$/
                                                ),
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value:
                                                              _vm.hcp
                                                                .ShiftAllowance,
                                                            expression:
                                                              "hcp.ShiftAllowance",
                                                            modifiers: {
                                                              trim: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: {
                                                          type: "text",
                                                          disabled:
                                                            !_vm.$Permission
                                                              .Appointment
                                                              .DLPermission
                                                              .IsValid,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.hcp
                                                              .ShiftAllowance,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.hcp,
                                                              "ShiftAllowance",
                                                              $event.target.value.trim()
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      errors
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.SalaryType === "月薪"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("勤工營養金"),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "勤工營養金",
                                              rules: {
                                                regex: new RegExp(
                                                  /^([0-9,]+)$/
                                                ),
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value:
                                                              _vm.hcp
                                                                .PerfectAttendanceBonus,
                                                            expression:
                                                              "hcp.PerfectAttendanceBonus",
                                                            modifiers: {
                                                              trim: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: {
                                                          type: "text",
                                                          disabled:
                                                            !_vm.$Permission
                                                              .Appointment
                                                              .DLPermission
                                                              .IsValid,
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.hcp
                                                              .PerfectAttendanceBonus,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.hcp,
                                                              "PerfectAttendanceBonus",
                                                              $event.target.value.trim()
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      errors
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.SalaryType === "月薪"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("伙食"),
                                          ]),
                                          _c("el-input", {
                                            attrs: {
                                              type: "text",
                                              clearable: "",
                                              maxlength: "20",
                                              disabled:
                                                !_vm.$Permission.Appointment
                                                  .DLPermission.IsValid,
                                              placeholder: "請輸入",
                                            },
                                            model: {
                                              value: _vm.hcp.Food,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.hcp,
                                                  "Food",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "hcp.Food",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.SalaryType === "月薪"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("其他津貼名稱"),
                                          ]),
                                          _c("el-input", {
                                            attrs: {
                                              type: "text",
                                              clearable: "",
                                              maxlength: "20",
                                              placeholder: "請輸入",
                                            },
                                            model: {
                                              value: _vm.hcp.OtherAllowanceName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.hcp,
                                                  "OtherAllowanceName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "hcp.OtherAllowanceName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.SalaryType === "月薪" &&
                              _vm.hcp.OtherAllowanceName
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("其他津貼"),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "其他津貼",
                                              rules: {
                                                regex: new RegExp(
                                                  /^([0-9,]+)$/
                                                ),
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value:
                                                              _vm.hcp
                                                                .OtherAllowance,
                                                            expression:
                                                              "hcp.OtherAllowance",
                                                            modifiers: {
                                                              trim: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value:
                                                            _vm.hcp
                                                              .OtherAllowance,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.hcp,
                                                              "OtherAllowance",
                                                              $event.target.value.trim()
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      errors
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("聘僱期間福利"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.BenefitType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "BenefitType",
                                              $$v
                                            )
                                          },
                                          expression: "hcp.BenefitType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "不發放三節獎金",
                                            value: "不發放三節獎金",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "按比例發放三節",
                                            value: "按比例發放三節",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "與正式人員同福利",
                                            value: "與正式人員同福利",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "其他",
                                            value: "其他",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm.hcp.BenefitType === "按比例發放三節"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-6 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("三節須年滿天數"),
                                          ]),
                                          _c("el-input-number", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              min: 0,
                                              max: 999,
                                              step: 1,
                                              precision: 0,
                                            },
                                            model: {
                                              value:
                                                _vm.hcp.HolidayBonusRequiredDay,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.hcp,
                                                  "HolidayBonusRequiredDay",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "hcp.HolidayBonusRequiredDay",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hcp.BenefitType === "其他"
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-12 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("福利說明"),
                                          ]),
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: 3,
                                              "show-word-limit": "",
                                              maxlength: "100",
                                            },
                                            model: {
                                              value: _vm.hcp.BenefitOtherDesc,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.hcp,
                                                  "BenefitOtherDesc",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "hcp.BenefitOtherDesc",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("加班計薪類型"),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "請選擇",
                                        },
                                        model: {
                                          value: _vm.hcp.OverTimeType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "OverTimeType",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "hcp.OverTimeType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "依照各類班制之規定辦理",
                                            value: "依照各類班制之規定辦理",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "依照人事政策",
                                            value: "依照人事政策",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "依照實際工作時數",
                                            value: "依照實際工作時數",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("試用期月數"),
                                    ]),
                                    _c("el-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: { min: 0, max: 99, precision: 0 },
                                      model: {
                                        value: _vm.hcp.ProbationMonth,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.hcp,
                                            "ProbationMonth",
                                            $$v
                                          )
                                        },
                                        expression: "hcp.ProbationMonth",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("是否進訓"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "form-group radio-style" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.IsNeedTraining,
                                          expression: "hcp.IsNeedTraining",
                                        },
                                      ],
                                      attrs: {
                                        id: "IsNeedTraining1",
                                        type: "radio",
                                        value: "true",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.IsNeedTraining,
                                          "true"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.IsNeedTraining
                                            ? (_vm.hcp.IsNeedTraining = null)
                                            : "true"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "IsNeedTraining",
                                            "true"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "mr-4",
                                        attrs: { for: "IsNeedTraining1" },
                                      },
                                      [_vm._v("是")]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.hcp.IsNeedTraining,
                                          expression: "hcp.IsNeedTraining",
                                        },
                                      ],
                                      attrs: {
                                        id: "IsNeedTraining2",
                                        type: "radio",
                                        value: "false",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.hcp.IsNeedTraining,
                                          "false"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.hcp.IsNeedTraining
                                            ? (_vm.hcp.IsNeedTraining = null)
                                            : "false"
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.hcp,
                                            "IsNeedTraining",
                                            "false"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "label",
                                      { attrs: { for: "IsNeedTraining2" } },
                                      [_vm._v("否")]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "col-md-12 col-sm-12" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("備註"),
                                      ]),
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          clearable: "",
                                          rows: 2,
                                          maxlength: "100",
                                          "show-word-limit": "",
                                          placeholder: "請輸入",
                                        },
                                        model: {
                                          value: _vm.hcp.Remark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.hcp,
                                              "Remark",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "hcp.Remark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.closeModal },
                            },
                            [_vm._v(" 關閉 ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return handleSubmit(_vm.saveHcp)
                                },
                              },
                            },
                            [_vm._v(" 儲存 ")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }